import Box from "@mui/material/Box";
import topBanner from "./top-banner.jpeg";

const assetBucket = "https://dwxmfgxgcusc8.cloudfront.net";
const ImageBanner = () => {
  return (
    <>
      <Box
        id="banner-container"
        sx={{
          position: "relative",
          height: "975px",
        }}
      >
        <Box>
          {/* <div
            id="banner-text"
            style={{
              width: "100%",
              textAlign: "center",
              zIndex: "500",
              fontStyle: "italic",
              color: "white",
              backgroundColor: "rgb(135, 153, 129)",
              position: "absolute",
            }}
          >
            TODO - add this?.
          </div> */}
          <div
            id="cc-name"
            style={{
              width: "100%",
              textAlign: "center",
              zIndex: "500",
              backgroundColor: "rgb(150,150,150)",
              color: "#d3d9d1",
              position: "absolute",
              fontFamily: "Garamond",
              fontVariant: "small-caps",
              // fontSize: navigator.maxTouchPoints > 0 ? "0.5em" : "1em",
            }}
          >
            Markt Heating and Cooling LLC
          </div>
          <Box
            component="img"
            id="banner-image"
            // sx={{
            //   position: "absolute",
            //   display: "block",
            //   overflow: "hidden",
            //   width: "100%",
            //   marginTop: "2%",
            //   height: "500px",
            //   objectFit: "cover",
            // }}
            // src={`${assetBucket}/top-banner.jpeg`}
            src={topBanner}
            alt="tree"
          />
        </Box>
      </Box>
    </>
  );
};

export default ImageBanner;
